<h2 mat-dialog-title>{{'Add Monthly Dashboard Messages' | translate | async}}</h2>
<mat-dialog-content>
<div class="Dialog-body">
  <form>
    <mat-form-field class="DBSS">
      <mat-select (selectionChange)="selectstate($event)" placeholder="{{'State' | translate | async}}"   [(ngModel)]="inputValuestate" name="Site" 
      [formControl]="state" required>            
        <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
          {{Site.SiteName}} </mat-option>
        </mat-select> 
        <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>
    
    <mat-form-field class="DBSS">
      <mat-select (selectionChange)="ChangeMonth($event)" placeholder="Month"  [(ngModel)]="Month"  name="Month" [value] = "Month">
        
        <mat-option [value]="1">{{'Janauary' | translate | async}}</mat-option>
        <mat-option [value]="2"> {{'February' | translate | async}}</mat-option>
        <mat-option [value]="3"> {{'March' | translate | async}} </mat-option>
        <mat-option [value]="4"> {{'April' | translate | async}} </mat-option>
        <mat-option [value]="5"> {{'May' | translate | async}} </mat-option>
        <mat-option [value]="6"> {{'June' | translate | async}}</mat-option>
        <mat-option [value]="7"> {{'July' | translate | async}}</mat-option>
        <mat-option [value]="8"> {{'August' | translate | async}}</mat-option>
        <mat-option [value]="9"> {{'September' | translate | async}}</mat-option>
        <mat-option [value]="10">{{'October' | translate | async}}</mat-option>
        <mat-option [value]="11">{{'November' | translate | async}}</mat-option>
        <mat-option [value]="12">{{'December' | translate | async}}</mat-option>


      </mat-select>
    </mat-form-field>

      <mat-form-field class="DBSS">
        <mat-select (selectionChange)="ChangeYear($event)" placeholder="{{'Year'  | translate | async}}" [(ngModel)]="Year"  name="Year" [value] = "Year">
        
          <mat-option [value]="2019">2019</mat-option>
          <mat-option [value]="2020">2020</mat-option>
          <mat-option [value]="2021">2021</mat-option>
          <mat-option [value]="2022">2022</mat-option>
          <mat-option [value]="2023">2023</mat-option>
          <mat-option [value]="2024">2024</mat-option>
          <mat-option [value]="2025">2025</mat-option>
          <mat-option [value]="2026">2026</mat-option>
          <mat-option [value]="2027">2027</mat-option>
          <mat-option [value]="2028">2028</mat-option>
          <mat-option [value]="2029">2029</mat-option>
          <mat-option [value]="2030">2030</mat-option>
        </mat-select>
      </mat-form-field> 

      <mat-form-field class="DBSS">
        <input matInput type="text" placeholder="{{'Focus Item' | translate | async}} " name = "FocusItems" [(ngModel)]="FocusItems" >  
      </mat-form-field>
      <mat-form-field class="DBSS">
        <input matInput type="text" placeholder="{{'Positives' | translate | async }}" name = "Positives" [(ngModel)]="Positives">  
      </mat-form-field>
      <mat-form-field class="DBSS">
        <input matInput type="text" placeholder="{{'Areas Of Improvement' | translate | async}} " name = "AreasImprovement" [(ngModel)]=" AreasImprovement">  
      </mat-form-field>
    
 
      <mat-form-field class="DBSS">
        <input matInput type="number" placeholder="{{'Take 5 target' | translate | async}} " min="1" name = "Take5Target" [(ngModel)]="Take5Target">   
      </mat-form-field>
      <mat-form-field class="DBSS">
        <input matInput type="number" placeholder="{{'Safety Inspection target' | translate | async}} " min="1"  name = "SafetyInspTarget"[(ngModel)]="SafetyInspTarget">   
      </mat-form-field>   
     
      <table class="table table--full-width table--striped">
       
          <tr>
            <th style="text-align: center;">{{'Month' | translate | async}}</th>
            <th style="text-align: center;">{{'Take 5 Target' | translate | async}}</th>
            <th style="text-align: center;">{{'Safety Inspection Target' | translate | async}}</th>
          </tr>
        
        <tbody>
          <tr *ngFor="let c of TargetList">
           
            <td style="text-align: center;">{{monthName(c.Month)}} {{c.Year}}</td>
            <td style="text-align: center;">{{c.Take5Target}}</td>
            <td style="text-align: center;">{{c.SafetyInspectionTarget}}</td>
           
          </tr>
        </tbody>
      </table>

  </form>
  
</div>
</mat-dialog-content>
<mat-dialog-actions style="align-items: flex-end;
display: flex;
flex-direction: row;
justify-content: flex-end;">
  <div class="buttonbelow">
    <button mat-raised-button (click)="DialogClose()">{{'Cancel' | translate | async}}</button> 
    <button mat-raised-button (click)= "saveMessage()">{{'Submit' | translate | async}}</button>         
  </div>
</mat-dialog-actions>
